var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaskByRectangle1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 350,
    height: 145,
    viewBox: "0 0 350 145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "vectorMask",
    width: 350,
    height: 145,
    rx: 18.35,
    fill: "#502c84"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_by_Rectangle",
    "data-name": "Mask by Rectangle",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_by_Rectangle-2",
    "data-name": "Mask by Rectangle",
    transform: "translate(-434.467 -283.213)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 350,
    height: 163.062,
    transform: "translate(434.467 283.213)",
    fill: "#673ab7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 434.35,
    cy: 283.129,
    rx: 434.35,
    ry: 283.129,
    fill: "#7f45d1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy_3",
    "data-name": "Oval Copy 3",
    cx: 315.679,
    cy: 205.778,
    rx: 315.679,
    ry: 205.778,
    transform: "translate(118.671 77.351)",
    fill: "#60349e"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy_2",
    "data-name": "Oval Copy 2",
    cx: 221.645,
    cy: 144.479,
    rx: 221.645,
    ry: 144.479,
    transform: "translate(212.726 138.671)",
    fill: "#41236b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy",
    "data-name": "Oval Copy",
    cx: 122.203,
    cy: 79.659,
    rx: 122.203,
    ry: 79.659,
    transform: "translate(312.147 203.47)",
    fill: "#221338"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaskByRectangle1);
export default __webpack_public_path__ + "static/media/Mask-by-Rectangle-1.c62da83dc78e475aebd947d23945e1ba.svg";
export { ForwardRef as ReactComponent };